(function () {
  if (window.__cqbInit) return;
  window.__cqbInit = true;

  function selectSize(btn) {
    var root = btn.closest('[data-cqb]');
    if (!root || btn.disabled) return;
    root.querySelectorAll('.cqb__size').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    var add = root.querySelector('[data-cqb-add]');
    if (add) add.dataset.variantId = btn.dataset.variantId;
    var size = root.querySelector('[data-cqb-size]');
    if (size) size.textContent = btn.dataset.size;
    var price = root.querySelector('[data-cqb-price]');
    if (price && btn.dataset.price) price.textContent = btn.dataset.price;
  }

  function addToCartCqb(add) {
    if (add.disabled || add.getAttribute('aria-busy') === 'true') return;
    add.setAttribute('aria-busy', 'true');
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: add.dataset.variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble,cart-live-region-text',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw data;
        add.classList.add('is-added');
        setTimeout(function () { add.classList.remove('is-added'); }, 1500);
        if (data.sections && typeof window.renderSections === 'function') {
          window.renderSections(data.sections);
        } else {
          window.location.href = base + 'cart';
        }
      })
      .catch(function (err) {
        console.error('[card-quick-buy]', err);
        if (err && err.description) window.alert && console.warn(err.description);
      })
      .finally(function () { add.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    var size = e.target.closest('.cqb__size');
    if (size) { e.preventDefault(); selectSize(size); return; }
    var add = e.target.closest('[data-cqb-add]');
    if (add) { e.preventDefault(); addToCartCqb(add); }
  });
})();
